import { useCallback } from 'react';

import { trackEvent } from '@zep/logger/tracking';

import { useAiBuilderChatActions } from '../stores';
import { type OpenAiBuilderChatParams } from '../stores/types';

import { useAiBuilderChatAvailability } from './useAiBuilderChatAvailability';

export const useOpenAiBuilderChat = () => {
  const { openFromEntry } = useAiBuilderChatActions();
  const { canUseAiBuilderChat } = useAiBuilderChatAvailability();

  return useCallback(
    (params: OpenAiBuilderChatParams) => {
      if (!canUseAiBuilderChat) {
        return;
      }

      openFromEntry(params);
      trackEvent('quiz_ai_builder_chat_open', {
        entry: params.entry,
        source: params.source,
      });
    },
    [canUseAiBuilderChat, openFromEntry],
  );
};
